module.exports = __webpack_public_path__ + "media/images/section2-9ec834bc9bfc3c0d5eed76c5ec725e50.png";